import axios, { AxiosInstance } from "axios";
import authTokenService from "common/authTokenService";
import { CancellationToken } from "common/ui/useCancellationToken";
import activeMerchantService from "features/merchants/activeMerchantService";

export default class HttpClient {

    static getProxyClient(merchantId?: Nullish<string>, cxt?: Nullish<CancellationToken>): AxiosInstance {
        return this.getClientInternal(import.meta.env.REACT_APP_PROXY_API_BASE_URL, merchantId, cxt);
    }

    static getAnonymousProxyClient(cxt: CancellationToken | null): AxiosInstance {
        return axios.create({
            baseURL: import.meta.env.REACT_APP_PROXY_API_BASE_URL,
            signal: cxt?.signal
        });;
    }

    private static getClientInternal(baseUrl: string, merchantId?: Nullish<string>, cxt?: Nullish<CancellationToken>): AxiosInstance {
        const defaultHeaders = {
            Authorization: `Bearer ${authTokenService.getToken()}`,
            'x-merchant-id': merchantId ?? activeMerchantService.getActiveMerchant()
        };

        const client = axios.create({
            baseURL: baseUrl,
            headers: defaultHeaders,
            signal: cxt?.signal
        });

        return client;
    }
}